<template>
    <div>
        <template>
            <div class="page-top mb-1 clearfix d-flex justify-content-end mt-3">
                <button class="btn btn-primary mb-3 ml-2"
                        data-target="#rightModal"
                        data-toggle="modal" style="background-color: white;border: #f0f1f3 solid 1px;padding: 8px 8px; color:black">
                    Filter <img src="/images/filter.png"/>
                </button>
            </div>
            <div aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal right fade" id="rightModal"
                 role="dialog" tabindex="-1">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="mb-1 modal-header">
                            <div class="modal-title"><h5 class="modal-title"><span class="align-middle">Search</span>
                            </h5></div>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="form-group m-0 mb-3 col-lg-12 col-md-6">
                                    <label class="label block-label"> From Date </label>
                                    <datepicker :bootstrap-styling="true"  name="fromDate"
                                                placeholder="From Date" v-model="fromDate" ></datepicker>
                                </div>
                                <div class="form-group m-0 mb-3 col-lg-12 col-md-6">
                                    <label class="label block-label"> To Date </label>
                                    <datepicker :bootstrap-styling="true" input-class="datepicker" name="toDate"
                                                placeholder="To Date" v-model="toDate" ></datepicker>
                                </div>
                            </div>
                            <div class="form-group m-0 mb-3">
                                <label class="label block-label"> Company</label>
                                <select class="form-control selectpicker custom-select2" data-live-search="true" id="company" name="companyId"
                                        v-model="companyId">-->
                                    <option selected value="">Select Company</option>
                                    <option v-bind:key="company.id" v-bind:value="company.id"
                                            v-for="company in companies">
                                        {{ company.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group m-0 mb-3">
                                <label class="label block-label"> Account Number</label>
                                <input class="form-control" companyName="" name="account_number" type="text"
                                       v-model="account_number"/>
                            </div>
                            <div class="form-group m-0 mb-3">
                                <label class="label block-label">Amount</label>
                                <input class="form-control" companyName="" name="amount" type="text"
                                       v-model="amount"/>
                            </div>
                            <div class="form-group m-0 mb-3">
                                <label class="label block-label"> Batch Id</label>
                                <input class="form-control" companyName="" name="batchID" type="text"
                                       v-model="batchID"/>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary float-right active m-0" id="customSearch">Search</button>
                            <button class="btn btn-primary float-right m-0 ml-2" data-dismiss="modal" type="button">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <table class="table" id="ReconTransactionTable" width="100%">
                <thead>
                <tr>
                    <th>Company</th>
                    <th>Company Type</th>
                    <th>Batch ID</th>
                    <th>Batch Name</th>
                    <th>Date</th>
                    <th>Action</th>
                </tr>
                </thead>
            </table>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data: null,
                pageView: null,
                edit_pending_batch: null,
                setToggle: false,
                companies: [],
                fromDate: '',
                toDate: '',
                companyId: '',
                account_number: '',
                amount: '',
                batchID: '',

            };
        },
        methods: {
            reloadList(tabClicked) {
                this.setToggle = !this.setToggle;
            },
            callDataTable() {
                const edit_permisison = this.edit_pending_batch
                let self = this;
                var ReconTransactionTable = $('#ReconTransactionTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    searching: true,
                    ajax: {
                        "url": "/api/listReconTransactions",
                        "data": function (d) {
                            if (self.fromDate && self.toDate) {
                                d.fromDate = moment(self.fromDate).format('YYYY-MM-DD');
                                d.toDate = moment(self.toDate).format('YYYY-MM-DD');
                            }
                            if (self.companyId) {
                                d.companyId = self.companyId;
                            }
                            if (self.account_number) {
                                d.account_number = self.account_number;
                            }
                            if (self.amount) {
                                d.amount = self.amount;
                            }
                            if (self.batchID) {
                                d.batchID = self.batchID;
                            }
                            d.transactionSource =  "FINCA"
                        },
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "type": 'POST',
                    },
                    deferRender: true,
                    columns: [
                        {
                            data: 'companyName', render: function (data, type, full) {
                                if (full['vrCorporate'] == 'YES') {
                                    var $type_badge = '<span class="badge badge-primary" data-toggle="tooltip" data-placement="top" title="Company Account Type: Virtual"> V </span> ';
                                } else {
                                    var $type_badge = '<span class="badge badge-success" data-toggle="tooltip" data-placement="top" title="Company Account Type: Corporate"> C </span> ';
                                }
                                return $type_badge + data;
                            }
                        },
                        {
                            data: 'vrCorporate', render: function (data, type, full) {
                                if (full['vrCorporate'] == 'YES') {
                                    var $type_label = 'Virtual';
                                } else {
                                    var $type_label = 'Corporate';
                                }
                                return $type_label;
                            }
                        },
                        {data: 'id'},
                        {data: 'name'},
                        {data: 'updated_at'},
                        {
                            data: 'id', sorting: false, render: function (data, type, full) {
                                var $url = '/reconBatchList/' + full['id'];
                                if (edit_permisison === true) {
                                    return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\'' + $url + '\')" class="btn btn-primary">Recon</a>';
                                } else {
                                    return 'N/A';
                                }
                            }
                        }

                    ],
                    "order": [[0, "desc"]],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                $('#search_active').on('keyup', function (e) {
                    if (e.keyCode === 13) {
                        ReconTransactionTable.search(this.value).draw();
                    }
                });

                $('#customSearch').on('click', function (e) {
                    $('#rightModal').modal('hide');
                    ReconTransactionTable.search(this.value).draw();
                });
            },
            getCompanies() {
                this.$Progress.start();
                axios.get('/api/getCompanies')
                    .then(res => {
                        if (res.status == 200) {
                            this.companies = res.data;
                            this.$Progress.finish();
                        } else {
                            this.$Progress.fail();
                            this.showAlertBox('error', 'Some error in your form data');
                        }
                    }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                    .catch(err => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.showAlertBox('error', 'Some error in your form data');
                    });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can('edit_pending_batch').then(result => {
                if (result.edit_pending_batch == true) {
                    this.edit_pending_batch = true;
                    this.getCompanies();
                    this.callDataTable();
                } else {
                    this.edit_pending_batch = false;
                    this.getCompanies();
                    this.callDataTable();
                }
            }).then(result => {
                if (this.edit_complaints == true) {
                    this.$Progress.finish();
                } else {
                    this.$Progress.finish();
                }
            });

        },
    }
</script>
<style scoped>
    .modal .modal-dialog {
        position: fixed;
        margin: auto;
        width: 400px;
        height: 100%;
        transform: translate3d(0%, 0, 0);
    }

    .modal .modal-content {
        height: 100%;
        overflow-y: auto;
    }

    .modal .modal-body {
        padding: 15px 22px 3px;
    }

    .modal.left.fade .modal-dialog {
        left: -320px;
        transition: opacity 0.1s linear, left 0.1s ease-out;
    }

    .modal.left.fade.show .modal-dialog {
        left: 0;
    }

    .modal.right.fade .modal-dialog {
        right: -320px;
        transition: opacity 0.1s linear, right 0.1s ease-out;
    }

    .modal.right.fade.show .modal-dialog {
        right: 0;
    }
    .modal-content {
        border-radius: 0;
        border: none;
    }
    .modal-header {
        border-bottom-color: #eeeeee;
        background-color: #fafafa;
    }

</style>

